<template>
  <el-form :rules="codeRule" :model="form">
    <!-- <el-form-item prop="code">
      <el-input
        v-model.trim="form.code"
        class="code-inp"
        oninput="value=value.replace(/[^\d]/g,'')"
        maxlength="6"
        name="code"
        autocomplete="off"
        placeholder="请输入验证码"
        @focus="codeFocus"
        @blur="codeBlur"
      >
        <i slot="prefix" class="iconfont iconyanzhengma" ref="codeIcon"/>
      </el-input>
      <span class="code" :class="{'disable':codeTxt != '发送验证码'}"  @click="getCode">{{ codeTxt }}</span>
      <span id="getCode" class="none" />
    </el-form-item> -->
    <el-form-item prop="code">
                <el-input
                  v-model.trim="form.code"
                  placeholder="请输入短信验证码"
                  class="code_input"
                  oninput="value=value.replace(/[^\d]/g,'')"
                  maxlength="6"
                  style="width:200px;"
                ></el-input>
                <span
                  class="get_code"
                  @click="sendSysCode()"
                  >{{ codeButtonText }}</span
                >
              </el-form-item>
  </el-form>
</template>

<script>
import { mapMutations } from 'vuex'
import { validateCode } from '@/utils/validate'
import { api_userIsExist, api_sendSms, api_send_verificaCode } from '@/api/login'
export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    phone: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    },
    verification: Boolean
  },
  data() {
    return {
      form: {
        code: ''
      },
      codeRule: {
        code: [{ validator: validateCode, trigger: 'blur' }]
      },
      codeTxt: '发送验证码',
      timer: null,
      smsKey: '',
       codeButtonText: "发送验证码",
      isReady: true,
      showCertification: false,
      userInfoRes: "",
    }
  },
  watch: {
    'form.code'() {
      this.$emit('input', this.form.code)
    },
    value() {
      this.form.code = this.value
    }
  },
  mounted(){
    //   var getCode = document.getElementById('getCode');
    //     document.addEventListener("click", function(){},true)
  },
  created(){
        this.sendSysCode = this.debounce(this.sendSysCode, 1000, true);
  },
  methods: {
    ...mapMutations({
      SETREGISTERDATA: 'SETREGISTERDATA'
    }),
    async sendSysCode() {
        const bool = await this.userIsExist()
        if (!bool) return
        if(bool){
      if (!this.isReady)
        return this.$message.warning(`请${this.counter}秒后重试`);
      const changePasswParame = {
        type: 'smsPhoneLogin',
        phone: this.phone,
      };
      this.counter = 60;
    //   this.timer && clearInterval(this.timer);
    //   this.timer = setInterval(() => {
    //     if (this.counter > 0) {
    //       this.counter--;
    //       this.codeButtonText = `已发送(${this.counter})`;
    //     } else {
    //       this.isReady = true;
    //       clearInterval(this.timer);
    //     }
    //   }, 1000);
        this.timer =null;
       this.timer = setInterval(() => {
        if (this.counter  > 0) {
            
          this.counter--;
          this.codeButtonText = this.counter + 's后重新发送'
        } else {
          clearInterval(this.timer)
         this.isReady = true;
          this.codeButtonText = '发送验证码'
        }
      }, 1000)
      const res = await api_send_verificaCode(changePasswParame);
      if (res.resp_code == 60000) {
        this.isReady = false;
        this.smsKey = res.datas;
        this.$message.success({
          showClose: true,
          message: "发送成功",
          type: "success",
        });
        this.smsKey = res.datas
        this.$emit('getSmsKey', this.smsKey)
      } else {
        this.$message.error(res.resp_msg);
        clearInterval(this.timer);
      }
      }
    },
     codeFocus(){
        //   var icon=document.getElementsByClassName('iconzhanghao');
          this.$refs.codeIcon.style.color='#1458EA';
      },
       codeBlur(){
        //   var icon=document.getElementsByClassName('iconzhanghao');
          this.$refs.codeIcon.style.color='#9E9FAB';
      },
    testPhone(val) {
      const reg = /^[1]([3-9])[0-9]{9}$/
      console.log(reg.test(val))
      return reg.test(val)
    },
    countDown() {
      this.timer = null
      let n = 60
      this.timer = setInterval(() => {
        if (n > 0) {
            
          n--
          this.codeTxt = n + 's后重新发送'
        } else {
          clearInterval(this.timer)
          this.codeTxt = '发送验证码'
        }
      }, 1000)
    },
    async sendSms() {
      const res = await api_sendSms({
        phone: this.phone,
        type: 'smsPhoneLogin'
      })
      if (res.resp_code == 60000) {
        this.$message.success({
          showClose: true,
          message: '发送成功',
          type: 'success'
        })
        this.smsKey = res.datas
        this.$emit('getSmsKey', this.smsKey)
      } else if (res.resp_code == 60202) {
        clearInterval(this.timer)
        this.codeTxt = '发送验证码'
      } else {
        this.$message.error(res.resp_msg)
      }
    },
    // 判断用户是否为新用户
    async userIsExist() {
      if (!this.testPhone(this.phone)) {
        this.$message.error('请输入正确的手机号码')
        return false
      }

      const res = await api_userIsExist({ username: this.phone })

      if (res.resp_code == 60000) {
        if (this.type == 'login') {
          // 登录
          if (res.datas) {
            this.SETREGISTERDATA(this.phone)
            this.$emit('toAnother', 'register')
            return false
          } else {
            return true
          }
        } else if (this.type == 'register') {
          // 注册
          if (res.datas) {
            this.$emit('userIsRegist', false)
            return true
          } else {
            this.$message.error('用户已存在')
            this.$emit('userIsRegist', true)
            return false
          }
        } else if (this.type == 'rebuild') {
          // 忘记密码
          if (res.datas) {
            this.$message.error('用户不存在')
            return false
          } else {
            return true
          }
        } else if (this.type == 'bindPhone') {
          // 绑定手机
          if (res.datas) {
            return true
          } else {
            this.$message.error('手机号码已存在')
            return false
          }
        }
      }
    },
    async getCode() {
      // 获取验证码
      console.log(this.codeTxt)
      console.log(this.verification)
      if (this.codeTxt != '发送验证码') return

      if (this.verification) {
        const bool = await this.userIsExist()
        if (!bool) return

        this.countDown()
        this.sendSms()
      } else {
        document.getElementById('getCode').click()
        
      }
    },
     debounce(handler, delay = 100, immediate = true) {
        let timer = null,
            cancle;
        // 这里不要用箭头函数
        return function (...args) {
            return new Promise((resolve, reject) => {
                let content = this;
                if (timer) clearTimeout(timer);
                if (cancle) cancle(timer);
                // 如果immediate参数为true 那么第一次是立即请求，后面立即改为延迟请求
                if (immediate) {
                    execute();
                    immediate = false;
                } else {
                    timer = setTimeout(() => {
                        execute();
                    }, delay);
                }
                cancle = () => {
                    // 只有请求到了结果才算成功，再次之前任何下一次请求，都会取消上次请求
                    reject("请勿频繁操作");
                };
                function execute() {
                    // 判断返回是否为promise函数
                    let returned = handler.apply(content, args);
                    if (Promise[Symbol.hasInstance](returned)) {
                        returned.then((res) => {
                            resolve(res);
                        });
                    } else {
                        // 如果不是promise函数
                        resolve(returned)
                    }
                }
            });
        }
    },
  }
}
</script>

<style lang="scss" scoped>
.code-inp {
  width: 200px;
}
.code {
  width: 100px;
  height: 40px;
  display: inline-block;
  border-radius: 2px;
  text-align: center;
  line-height: 40px;
  color: #1458EA;
  font-size: 14px;
  margin-left: 15px;
  cursor: pointer;
  user-select: none;
  &.disable {
    color: #8492a6;
    &:hover {
      color: #8492a6;
    }
  }
}
.none {
  width: 0;
  height: 0;
  margin: 0;
  padding: 0;
}
</style>
